import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import {
  LayoutConfigService,
  TranslationService,
  JsonService,
  DataProcessingWorkspaceService,
  DataProcessingQueryDatasetService,
  DataVisualizationService,
} from 'src/app/libs/services';
import { LayoutConfigModel } from 'src/app/libs/models/common';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/libs/store/states';
import { UserSelector } from 'src/app/libs/store/selectors/authentication.selectors';
import { setApplicationByIdSelector } from 'src/app/libs/store/selectors/datavisualization.selector';
import { findTypeCheckByUrl } from 'src/app/libs/helpers/data-visualization-helper';
import { GeneralSaveTriggerActions } from 'src/app/libs/store/actions/general.actions';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmActionComponent } from 'src/app/components/modals/modalConfirmAction/modal-confirm-action..component';
import { SettingFilterModalComponent } from './setting-filter-modal/setting-filter-modal.component';

@Component({
  selector: 'setting-filter',
  templateUrl: './setting-filter.component.html',
  styleUrls: ['./setting-filter.component.scss']
})
export class SettingFilterComponent implements OnInit {
  @Input() isHideUserManagement;
  @ViewChild('toggleButton2') toggleButton: ElementRef;
  @ViewChild('menu2') menu: ElementRef;

  isAppPreview: boolean = false;
  isOpen: boolean = false;
  model: LayoutConfigModel;
  user: any;
  isAdministrator: boolean = false;
  isThemeSetting: boolean = true;
  modalReference: NgbModalRef;
  legend: string = 'default';
  label: string = 'default';
  constructor(
    private layoutConfigService: LayoutConfigService,
    private translationService: TranslationService,
    private router: Router,
    public cdRef: ChangeDetectorRef,
    private store: Store<AppState>,
    private modalService: NgbModal,
    private dataProcessingWorkspaceService: DataProcessingWorkspaceService,
    private dataProcessingQueryDatasetService: DataProcessingQueryDatasetService,
    private dataVisualizationService: DataVisualizationService
  ) {}

  environtmentType: any;

  ngOnInit(): void {
    this.translationService.setLanguage(this.translationService.getSelectedLanguage());
    this.model = this.layoutConfigService.getConfig();
    this.environtmentType = environment.type;
    this.isAppPreview = this.router.url.includes('app_preview');
  }
  handleDialog = () => {
    this.modalReference = this.modalService.open(SettingFilterModalComponent, {
      size: 'md',
      centered: true
    });
    this.modalReference.componentInstance.legend = this.legend;
    this.modalReference.componentInstance.label = this.label;

    this.modalReference.result.then(
      (res) => {
        this.legend = res.legend;
        this.label = res.label;
        sessionStorage.setItem('legend', this.legend);
        sessionStorage.setItem('label', this.label);
        this.dataVisualizationService.setHasFilterLabelLegendApplicationSubject(true);
        this.cdRef.detectChanges();
      },
      (reason: any) => {
      }
    );
  };
}
